import { LinkItem } from '@occc-app/design-system';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

import { routeCreator } from '../utils';

export const getBreadcrumbLinks = (productCategoryName: string | undefined): LinkItem[] => [
  { to: programManagementRouteCreator.base(), label: 'Program Management' },
  { to: routeCreator.list(), label: 'Product Preferences' },
  { key: routeCreator.create(), label: productCategoryName || 'Product Preference' },
];
